/**
 * aiOpsCopy.ts — the single source for the assistant-operations meter copy.
 *
 * These strings ship at C-WP4 (Settings → Plan meter) and are reused verbatim by
 * the C-WP5 paste pane's inline at-cap state — one source, no duplication. The
 * cadence follows the plan: free resets monthly (on the 1st), paid resets weekly
 * (on Monday), matching the server's window semantics (C-WP4).
 *
 * Voice: states what is true, no urgency, no "upgrade", no "credits", no
 * exclamations (branding.md §5, §5.2.1). The voice-copy-reviewer passes over
 * these; keep them dry.
 *
 * Refs:
 *   .plan/implementation/2026-07-10-track-c-ai-mcp-build-plan.md C-WP4, C-WP5
 */

/** The reset-cadence line, keyed by whether the plan resets weekly (paid). */
export const AI_OPS_RESET_LINE = {
  monthly: "Resets on the 1st.",
  weekly: "Resets Monday.",
} as const;

/** The at-cap prefix, prepended to the reset line when no operations remain. */
export const AI_OPS_AT_CAP_PREFIX = "No operations left.";

/** The reset-cadence line for a plan. Paid resets weekly; free resets monthly. */
export function aiOpsResetLine(isPaid: boolean): string {
  return isPaid ? AI_OPS_RESET_LINE.weekly : AI_OPS_RESET_LINE.monthly;
}

/** The full at-cap inline line — "No operations left. Resets on the 1st." */
export function aiOpsAtCapLine(isPaid: boolean): string {
  return `${AI_OPS_AT_CAP_PREFIX} ${aiOpsResetLine(isPaid)}`;
}
